import React from "react";
import styles from "./business-profile.module.css";
import StarIcon from "../Icons/star-icon";
import { useSelector } from "react-redux";
import { companyReviewSummarySelector } from "../../Reducers/companyReviewSummaryReducer";
import { activeCompanySelector } from "../../Reducers/activeCompanyReducer";
import Shimmer from "../CommonComponents/shimmer/Shimmer";

const QuickStatsTab = () => {
  const activeCompanyId = useSelector(activeCompanySelector);
  const companyReviewSummary = useSelector(companyReviewSummarySelector);

  const isLoading = companyReviewSummary.getCompanyId() !== activeCompanyId;


  return (
    <div className={styles.quickStatsRoot}>
      <div className={styles.kpiContainer}>
        {/* <div className={styles.kpiColumn}>
          <div className={styles.kpiTitle}>Total revenue</div>
          <div className={styles.kpiValue}>$78,412.20</div>
          <div className={styles.kpiSub}>Based on 2,357 orders</div>
        </div>
        <div className={styles.kpiColumn}>
          <div className={styles.kpiTitle}>Avg. revenue</div>
          <div className={styles.kpiValue}>$33.27</div>
          <div className={styles.kpiSub}>Based on 2,357 orders</div>
        </div> */}
        <div className={styles.kpiColumn}>
          <div className={styles.kpiTitle}>Order rating</div>
          <div className={styles.ratingRow}>
            {isLoading ? <Shimmer width={64} height={32} /> : <>
              <div className={styles.kpiValue}>{companyReviewSummary.getOrderAvg()}</div>
              <StarIcon width={18} height={18} fill="#EFB841" stroke="#E2A013" />
            </>}
          </div>
          <div className={styles.kpiSub}>
            {isLoading ? <Shimmer width={118} height={16} /> : <>Based on {companyReviewSummary.getOrderReviewsCount()} reviews</>}
          </div>
        </div>
        <div className={styles.kpiColumn}>
          <div className={styles.kpiTitle}>Delivery rating</div>
          <div className={styles.ratingRow}>
            {isLoading ? <Shimmer width={64} height={32} /> : <>
              <div className={styles.kpiValue}>{companyReviewSummary.getDriverAvg()}</div>
              <StarIcon width={18} height={18} fill="#EFB841" stroke="#E2A013" />
            </>}
          </div>
          <div className={styles.kpiSub}>
            {isLoading ? <Shimmer width={118} height={16} /> : <>Based on {companyReviewSummary.getDriverReviewsCount()} reviews</>}
          </div>
        </div>
      </div>

      <div className={styles.sections}>
        {/* <div className={styles.section}>
          <div className={styles.sectionHeader}>
            <div className={styles.sectionTitle}>Total orders</div>
            <div className={styles.sectionValue}>2,357</div>
          </div>
          <div className={styles.sectionMetaRow}>
            <div className={styles.metaGroup}>
              <div className={styles.metaLabel}>Last order</div>
              <div className={styles.metaValue}>June 25, 2025</div>
            </div>
            <div className={styles.inlineSpacer} />
            <div className={styles.metaGroup}>
              <div className={styles.metaLabel}>Frequency order</div>
              <div className={styles.metaValue}>Every 3 days</div>
            </div>
          </div>
        </div>

        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            <div className={styles.sectionTitle}>Delivery orders</div>
            <div className={styles.sectionValue}>1,892</div>
          </div>
          <div className={styles.sectionMetaRow}>
            <div className={styles.metaGroup}>
              <div className={styles.metaLabel}>Avg. per order</div>
              <div className={styles.metaValue}>$34.10</div>
            </div>
            <div className={styles.inlineSpacer} />
            <div className={styles.metaGroup}>
              <div className={styles.metaLabel}>Last order</div>
              <div className={styles.metaValue}>June 25, 2025</div>
            </div>
          </div>
        </div>

        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            <div className={styles.sectionTitle}>Takeout orders</div>
            <div className={styles.sectionValue}>288</div>
          </div>
          <div className={styles.sectionMetaRow}>
            <div className={styles.metaGroup}>
              <div className={styles.metaLabel}>Avg. per order</div>
              <div className={styles.metaValue}>$30.45</div>
            </div>
            <div className={styles.inlineSpacer} />
            <div className={styles.metaGroup}>
              <div className={styles.metaLabel}>Last order</div>
              <div className={styles.metaValue}>June 20, 2025</div>
            </div>
          </div>
        </div>

        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            <div className={styles.sectionTitle}>Dine-in orders</div>
            <div className={styles.sectionValue}>177</div>
          </div>
          <div className={styles.sectionMetaRow}>
            <div className={styles.metaGroup}>
              <div className={styles.metaLabel}>Avg. per order</div>
              <div className={styles.metaValue}>$28.95</div>
            </div>
            <div className={styles.inlineSpacer} />
            <div className={styles.metaGroup}>
              <div className={styles.metaLabel}>Frequency</div>
              <div className={styles.metaValue}>Every 6 days</div>
            </div>
            <div className={styles.inlineSpacer} />
            <div className={styles.metaGroup}>
              <div className={styles.metaLabel}>Last order</div>
              <div className={styles.metaValue}>June 18, 2025</div>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default QuickStatsTab;
